export function AuroraBackground() {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {/* Primary aurora blob */}
      <div 
        className="absolute top-0 left-1/4 w-[800px] h-[600px] rounded-full blur-[120px] opacity-20 animate-float"
        style={{
          background: 'radial-gradient(circle, rgba(212, 168, 83, 0.4) 0%, transparent 70%)',
        }}
      />
      
      {/* Secondary aurora blob */}
      <div 
        className="absolute bottom-0 right-1/4 w-[600px] h-[500px] rounded-full blur-[100px] opacity-15 animate-float"
        style={{
          background: 'radial-gradient(circle, rgba(167, 139, 250, 0.35) 0%, transparent 70%)',
          animationDelay: '-3s',
        }}
      />
      
      {/* Accent blob */}
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[400px] rounded-full blur-[150px] opacity-10"
        style={{
          background: 'radial-gradient(circle, rgba(244, 114, 182, 0.3) 0%, transparent 70%)',
        }}
      />

      {/* Subtle grid pattern */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: '100px 100px',
        }}
      />
    </div>
  );
}
